import httpManager from "@/app/shared/utils/httpManager";

export async function downloadErrors(id) {
  const response = await httpManager.getBlob(`/imports/${id}/errors/`);

  return response;
}
